import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';

import { MediaQueryService } from '@app/@core/breakpoints';
import { PreloadRectComponent } from '@app/@core/common/directives';
import { DateUtcComponent } from '@app/@core/date';
import { AnimatedCardComponent } from '@app/modules/payment/components/animated-card/animated-card.component';
import { ImageUrlPipe } from '@app/modules/payment/pipes/image-url.pipe';
import { ProfileState } from '@app/modules/users/profile.state';
import { CurrencyInputComponent } from '@app/ui/components/currency-input/currency-input.component';
import { indicateLoading } from '@core/helpers';

@Component({
  selector: 'deposits-table',
  styleUrls: ['./deposits.component.scss'],
  templateUrl: './deposits.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    AnimatedCardComponent,
    DateUtcComponent,
    NgClass,
    RouterLink,
    ImageUrlPipe,
    PreloadRectComponent,
    CurrencyInputComponent,
    NgTemplateOutlet
  ],
  host: { class: 'flex items-center justify-center w-full' }
})
export default class DepositsTable implements OnInit {
  public readonly profileState = inject(ProfileState);

  private readonly mediaService = inject(MediaQueryService);

  public readonly isLg = toSignal(this.mediaService.mediaQuery('max', 'lg'));

  private readonly destroyRef = inject(DestroyRef);

  public readonly isLoading = signal<boolean>(false);

  public readonly preloadRows = new Array(10);

  ngOnInit(): void {
    this.loadDeposits();
  }

  private loadDeposits(): void {
    this.profileState
      .loadDeposits()
      .pipe(indicateLoading(this.isLoading), takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
